/* Copyright (C) Envialo México SA de CV - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by:
 * @author América Mendoza  <amendoza@nodeport.co>,
 * @author Darién Miranda <dmiranda@nodeport.co>,
 * August 2026
 */

import React from 'react';
import {withRouter} from "react-router";
import Badge from "react-bootstrap/Badge";
import PropTypes from "prop-types";
import Row from "react-bootstrap/cjs/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import OdooLogo from "../../assets/odoo192.png";
import "dayjs/locale/es"; // Importar el idioma español

//components
import {money} from "../../lib/money/money";

//style
import "../../scss/components/ordersKanbanColumn.scss";

//const
const dayjs = require('dayjs')
const relativeTime = require('dayjs/plugin/relativeTime');
dayjs.extend(relativeTime);
dayjs.locale("es");



const getUser = (order) =>{
    if(order.user){
        return order.user;
    }else{
        return {
            name:order?.shipping?.name,
            lastName:order?.shipping?.lastName,
            email:order?.contact?.email
        }
    }
}

const renderPaymentStatus = (paymentStatus) => {
    let variant = '';
    let txt     = paymentStatus;
    switch (paymentStatus) {
        case 'paid':
            variant = 'custom-success';
            txt     = 'Pagado';
            break;
        case 'pending':
            variant = 'custom-warning';
            txt     = 'Pendiente de pago';
            break;
        default:
            variant = 'custom-danger';
            break;
    }
    return (
        <Badge className={'ml-1'} bg={variant}>{txt}</Badge>
    )
}

const fromNowDate = (date) => {
    if (!date) {
        return 'Sin fecha';
    }
    return dayjs(date).fromNow();
}

class OrdersKanbanColumn extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Row>
                <Col>
                    <Card className={'kanban-column'}>
                        <Card.Header className={'d-flex align-items-center'}>
                            <span className={'text-dark'}>{this.props.orderTypeName}</span>
                            <Badge className={'ml-2 badge-header-column'}>{this.props.orders.length}</Badge>
                        </Card.Header>
                        <Card.Body>
                            {
                                this.props.orders.map((order) => {
                                    const user = getUser(order);
                                    return(
                                        <Card className={'kanban-card mb-2'} key={`keyOrderCard${order.seqOrderId}`}>
                                            <div className={'p-2'}>
                                                <div className={'d-flex align-items-center justify-content-between'}>
                                                    <a href={`/orders/${order._id}`}>{user.name} {user.last_name || user.lastName}</a>
                                                    <Button variant="link"
                                                            size={'sm'}
                                                            className={'mr-0 pr-0'}
                                                            target={'_blank'}
                                                            href={`${process.env.REACT_APP_ODOO_DASHBOARD_URL}/sales/${order.odooOrderId}`}>
                                                        <img className={'odoo-link'} src={OdooLogo} width={"20px"} height={'20px'} alt={'logo odoo'} />
                                                    </Button>
                                                </div>
                                                <div className={'d-flex align-items-center justify-content-between my-3'}>
                                                    <h6 className={'text-dark mb-0'}>{money(order.total)}</h6>
                                                    {renderPaymentStatus(order.paymentStatus)}
                                                </div>
                                                <div className={'d-flex align-items-center border-top p-t-5'}>
                                                    <small>
                                                        {fromNowDate(order.created_at)}
                                                    </small>
                                                </div>
                                            </div>
                                         </Card>
                                    )}
                                )
                            }
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        )
    }


}

export default withRouter(OrdersKanbanColumn);

OrdersKanbanColumn.propTypes    = {
    orders: PropTypes.array,
    orderTypeName: PropTypes.string,
    isLoading: PropTypes.bool,
    pages: PropTypes.number,
    currentPage: PropTypes.number,
    onPageChanged: PropTypes.func,
    routes: PropTypes.array,
    onClickCreateRoute: PropTypes.func,
    onRouteUpdated: PropTypes.func
}
OrdersKanbanColumn.defaultProps = {
    orders     : [],
    orderTypeName: '',
    isLoading  : true,
    pages      : 1,
    currentPage: 1,
    onPageChanged: () => {},
    routes: [],
    onClickCreateRoute: () => {},
    onRouteUpdated: () => {}
}
